import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w100 pad20" }
const _hoisted_2 = {
  key: 0,
  class: "mb40"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs16 fw600" }, "振り分けルール一覧")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_6 = { class: "mt20" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "上記に該当がない場合", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "w100 pad10" }
const _hoisted_10 = {
  class: "fl",
  style: {"width":"300px"}
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "mb40"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "mt20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs16 fw600" }, "ルールを編集")
], -1)
const _hoisted_18 = { class: "" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "以下に該当したら", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fl fs11" }, "質問を選択", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt15 ml5" }, "が", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = {
  style: {"width":"100px"},
  class: "fl"
}
const _hoisted_28 = {
  key: 0,
  class: "fs11 mt20 mr10 fw600"
}
const _hoisted_29 = {
  key: 1,
  class: "fs11 mt20 mr10 nodisp"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = {
  class: "fr ml10 mt15",
  style: {"width":"150px"}
}
const _hoisted_32 = { class: "centering" }
const _hoisted_33 = ["src", "onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "w100 mt20 ml20"
}
const _hoisted_36 = {
  style: {"width":"100px"},
  class: "fl"
}
const _hoisted_37 = {
  key: 0,
  class: "fs11 mt20 mr10 fw600"
}
const _hoisted_38 = {
  key: 1,
  class: "fs11 mt20 mr10"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = { class: "w100 mt40" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "fl fs11 label dblueBg" }, "以下に進みます", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_47 = { class: "w100 pad10" }
const _hoisted_48 = {
  class: "fl",
  style: {"width":"300px"}
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_54 = { class: "w100 mt20" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OneConditionContent = _resolveComponent("OneConditionContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.viewType == `list`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "fr pointer centered circle_button blueAround fs14 rad8 mt15 ml20 fw600",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewCondition && _ctx.addNewCondition(...args)))
          }, " 振り分けルールを追加 "),
          _hoisted_3,
          _hoisted_4,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fcm.conds, (cond, condindex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "w100",
              key: `${condindex}${cond.updated_at}${cond.created_at}${cond.id}`
            }, [
              _createVNode(_component_OneConditionContent, {
                cond: cond,
                condindex: condindex,
                total: _ctx.fcm.conds.length,
                fieldPublicIdDic: _ctx.fieldPublicIdDic,
                onEditCondition: ($event: any) => (_ctx.editCondition(cond, condindex)),
                onClickUp: _ctx.clickUp,
                onClickDown: _ctx.clickDown,
                onRemoveCondition: ($event: any) => (_ctx.removeCondition(cond, condindex))
              }, null, 8, ["cond", "condindex", "total", "fieldPublicIdDic", "onEditCondition", "onClickUp", "onClickDown", "onRemoveCondition"])
            ]))
          }), 128)),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_SelectTag, {
                name: "members_names",
                id: "select_members_names",
                class: "fl fs14 roundForm mr20 mt10",
                style: {"min-width":"300px","height":"50px"},
                options: Object.values(_ctx.AssignCondition.DEST_TYPES_JP),
                defaultOption: 
                            _ctx.fcm.aform.no_match_destination_type
                                ? _ctx.AssignCondition.DEST_TYPES_JP[_ctx.fcm.aform.no_match_destination_type]
                                : null
                        ,
                needUnselect: true,
                onSelectValue: _ctx.selectNoMatchDestinationType,
                isDisabled: false
              }, null, 8, ["options", "defaultOption", "onSelectValue"]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.fcm.aform.no_match_destination_type == `public_room`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_MdTextfieldTag, {
                        type: "text",
                        name: "公開ページIDを入力",
                        value: _ctx.fcm.aform.no_match_destination_value,
                        placeholder: "公開ページIDを入力(Pから始まる英数字)",
                        onInputValue: _ctx.updateNoMatchDestinationValue,
                        isDisabled: false
                      }, null, 8, ["value", "onInputValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.fcm.aform.no_match_destination_type == `url`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_MdTextfieldTag, {
                        type: "text",
                        name: "URLを入力",
                        value: _ctx.fcm.aform.no_match_destination_value,
                        placeholder: "URLを入力",
                        onInputValue: _ctx.updateNoMatchDestinationValue,
                        isDisabled: false
                      }, null, 8, ["value", "onInputValue"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.fcm.aform.no_match_destination_type == `end_with_message`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_TextareaTag, {
                        placeholder: "お問い合わせいただきありがとうございました。",
                        class: "fl fs14 roundForm mw100 rad20 llgreyBg mt20",
                        style: `height:300px;padding:20px;`,
                        value: _ctx.fcm.aform.no_match_destination_value,
                        onInputValue: _ctx.updateNoMatchDestinationValue
                      }, null, 8, ["value", "onInputValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_14
            ])
          ])
        ]))
      : (_ctx.viewType == `detail`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.edittingCondition.answer_condition_groups || [], (acg, acgindex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${acgindex}${_ctx.updateTime}`
                  }, [
                    _hoisted_19,
                    _hoisted_20,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acg.answer_conditions, (acond, acondindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "w100 pad10",
                        key: `${acondindex}${acond.field_public_id}`
                      }, [
                        _hoisted_21,
                        _hoisted_22,
                        _createVNode(_component_SelectTag, {
                          name: "members_names",
                          id: "select_members_names",
                          class: "fl fs14 roundForm",
                          style: {"min-width":"300px","height":"50px"},
                          options: _ctx.selectableValues || [],
                          defaultOption: acond.field_public_id ? _ctx.fieldPublicIdDic[acond.field_public_id].field_name : null,
                          needUnselect: true,
                          returnVal: [acgindex, acondindex],
                          onSelectValue: _ctx.selectFieldValue,
                          isDisabled: false
                        }, null, 8, ["options", "defaultOption", "returnVal", "onSelectValue"]),
                        _hoisted_23,
                        _hoisted_24,
                        (acond.field_public_id)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              _createVNode(_component_SelectTag, {
                                name: "members_names",
                                id: "select_members_names",
                                class: "fl fs14 mt20 roundForm",
                                style: {"min-width":"300px","height":"50px"},
                                options: 
                                        _ctx.AnswerCondition.isTextType(_ctx.fieldPublicIdDic[acond.field_public_id].field_type)
                                            ? _ctx.AnswerCondition.TEXT_TYPES.map(t => _ctx.AnswerCondition.TYPE_JP[t])
                                            : _ctx.AnswerCondition.SELECT_TYPES.map(t => _ctx.AnswerCondition.SELECT_TYPE_JP[t])
                                    ,
                                defaultOption: 
                                        acond.compare_type
                                            ? _ctx.AnswerCondition.isTextType(_ctx.fieldPublicIdDic[acond.field_public_id].field_type)
                                                ? _ctx.AnswerCondition.TYPE_JP[acond.compare_type]
                                                : _ctx.AnswerCondition.SELECT_TYPE_JP[acond.compare_type]
                                            : null
                                    ,
                                needUnselect: true,
                                returnVal: [acgindex, acondindex],
                                onSelectValue: _ctx.selectConditionType,
                                isDisabled: false
                              }, null, 8, ["options", "defaultOption", "returnVal", "onSelectValue"]),
                              _hoisted_26,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acond.text_value_arr, (textValue, valueindex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "w100 mt20 ml20",
                                  key: valueindex
                                }, [
                                  _createElementVNode("div", _hoisted_27, [
                                    (valueindex != 0)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, "または"))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_29, " ")),
                                    ((acond.text_value_arr || []).length > 0 && valueindex == 0)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 2,
                                          class: "fl pointer centered circle_button blueAround fs14 rad20 fw600 pad15",
                                          style: {"height":"50px"},
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNewRule(`and`)))
                                        }, " + さらに "))
                                      : _createCommentVNode("", true)
                                  ]),
                                  (_ctx.AnswerCondition.isTextType(_ctx.fieldPublicIdDic[acond.field_public_id].field_type))
                                    ? (_openBlock(), _createBlock(_component_TextfieldTag, {
                                        key: 0,
                                        class: "fl ml20",
                                        type: "text",
                                        name: "end_with_message",
                                        value: textValue,
                                        placeholder: "条件に合致する値を入力",
                                        returnVal: [acgindex, acondindex, valueindex],
                                        onInputValue: _ctx.inputCondValue,
                                        isDisabled: false
                                      }, null, 8, ["value", "returnVal", "onInputValue"]))
                                    : (_openBlock(), _createBlock(_component_SelectTag, {
                                        key: 1,
                                        name: "members_names",
                                        id: "select_members_names",
                                        class: "fl fs14 roundForm ml20",
                                        style: {"min-width":"300px","height":"50px"},
                                        options: 
                                            (_ctx.fieldPublicIdDic[acond.field_public_id]?.selectable_values || []).map(v => v.value)
                                        ,
                                        defaultOption: textValue,
                                        needUnselect: true,
                                        returnVal: [acgindex, acondindex, valueindex],
                                        onSelectValue: _ctx.selectCondValue,
                                        isDisabled: false
                                      }, null, 8, ["options", "defaultOption", "returnVal", "onSelectValue"])),
                                  ((acond.text_value_arr || []).length == valueindex + 1)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "fl pointer centered circle_button blueAround fs14 rad20 ml20 fw600 pad15",
                                        style: {"height":"50px"},
                                        onClick: ($event: any) => (_ctx.addNewRule(`or`, acond))
                                      }, " + または ", 8, _hoisted_30))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createElementVNode("img", {
                                        src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                        width: "20",
                                        height: "23",
                                        class: "pointer fl mr15",
                                        onClick: ($event: any) => (_ctx.removeRule(acond, valueindex))
                                      }, null, 8, _hoisted_33)
                                    ])
                                  ]),
                                  _hoisted_34
                                ]))
                              }), 128)),
                              (
                                        !_ctx.AnswerCondition.isTextType(_ctx.fieldPublicIdDic[acond.field_public_id].field_type) &&
                                        ((acond.text_value_arr || []).length == 0 || (acond.text_value_arr || []).length > 0)
                                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                    _createElementVNode("div", _hoisted_36, [
                                      ((acond.text_value_arr || []).length != 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_37, "または"))
                                        : (_openBlock(), _createElementBlock("p", _hoisted_38, " "))
                                    ]),
                                    _createVNode(_component_SelectTag, {
                                      name: "members_names",
                                      id: "select_members_names",
                                      class: "fl fs14 roundForm",
                                      style: {"min-width":"300px","height":"50px"},
                                      options: 
                                            (_ctx.fieldPublicIdDic[acond.field_public_id]?.selectable_values || []).map(v => v.value)
                                        ,
                                      defaultOption: _ctx.newTextValue,
                                      needUnselect: true,
                                      returnVal: [acgindex, acondindex, (acond.text_value_arr || []).length],
                                      onSelectValue: _ctx.selectCondValue,
                                      isDisabled: false
                                    }, null, 8, ["options", "defaultOption", "returnVal", "onSelectValue"]),
                                    _hoisted_39
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_40
                      ]))
                    }), 128)),
                    _hoisted_41
                  ]))
                }), 128)),
                _hoisted_42
              ]),
              _hoisted_43
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_component_SelectTag, {
                  name: "members_names",
                  id: "select_members_names",
                  class: "fl fs14 roundForm mr20 mt10",
                  style: {"min-width":"300px","height":"50px"},
                  options: Object.values(_ctx.AssignCondition.DEST_TYPES_JP),
                  defaultOption: 
                            _ctx.edittingCondition.destination_type
                                ? _ctx.AssignCondition.DEST_TYPES_JP[_ctx.edittingCondition.destination_type] || null
                                : null
                        ,
                  needUnselect: true,
                  onSelectValue: _ctx.selectDestinationType,
                  isDisabled: false
                }, null, 8, ["options", "defaultOption", "onSelectValue"]),
                _createElementVNode("div", _hoisted_48, [
                  (_ctx.edittingCondition.destination_type == `public_room`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                        _createVNode(_component_MdTextfieldTag, {
                          type: "text",
                          name: "公開ページIDを入力",
                          value: _ctx.edittingCondition.destination_value,
                          placeholder: "公開ページIDを入力(Pから始まる英数字)",
                          onInputValue: _ctx.updateDestinationValue,
                          isDisabled: false
                        }, null, 8, ["value", "onInputValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.edittingCondition.destination_type == `url`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createVNode(_component_MdTextfieldTag, {
                          type: "text",
                          name: "URLを入力",
                          value: _ctx.edittingCondition.destination_value,
                          placeholder: "URLを入力",
                          onInputValue: _ctx.updateDestinationValue,
                          isDisabled: false
                        }, null, 8, ["value", "onInputValue"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.edittingCondition.destination_type == `end_with_message`)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_component_TextareaTag, {
                          placeholder: "お問い合わせいただきありがとうございました。",
                          class: "fl fs14 roundForm mw100 rad20 llgreyBg mt20",
                          style: `height:300px;padding:20px;`,
                          value: _ctx.edittingCondition.destination_value,
                          onInputValue: _ctx.updateDestinationValue
                        }, null, 8, ["value", "onInputValue"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_52
              ])
            ]),
            _hoisted_53,
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("div", {
                class: "fr pointer centered circle_button skyblueBg fs14 rad8 ml20 fw600",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveRule && _ctx.saveRule(...args)))
              }, "ルールを決定"),
              _createElementVNode("div", {
                class: "fr pointer centered underline fs14 rad8 mt10 ml20",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelRule && _ctx.cancelRule(...args)))
              }, "変更をキャンセル"),
              _hoisted_55
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}